import styled from 'styled-components'
import { releaseInfoTabletUpQuery } from '../../responsiveQueries'

export const Promo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  width: 100%;
  background: ${({ theme }) => theme.colors.neutralW10};
`

export const PromoContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background: transparent;
`

export const PromoContent = styled.div`
  flex: 1 1 auto;
  width: 100%;
  padding: 0 16px 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #444;
    border-radius: 4px;
  }

  @media ${releaseInfoTabletUpQuery} {
    padding: 0 24px 24px;
  }
`

export const PromoMarkup = styled.div`
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  color: #1a1a1a;
`
